let faker = require('faker');

const getMessageList = () => {
    const t = [];
    const isMessageOption = faker.random.boolean();
    for (let k = 0; k < faker.random.number({ max: 2, min: 1 }); k++) {
        t.push({
            id: k,
            options: [
                {
                    index: 0,
                    id: faker.random.number(),
                    text: faker.lorem.paragraph()
                },
                {
                    index: 1,
                    id: faker.random.number(),
                    text: faker.lorem.paragraph()
                },
                {
                    index: 2,
                    id: faker.random.number(),
                    text: faker.lorem.paragraph()
                },
                {
                    index: 3,
                    id: faker.random.number(),
                    text: faker.lorem.paragraph()
                }
            ],
            isMessageSelctor: isMessageOption,
            isMessageArranger: !isMessageOption
        })
    }
    return t;
};

export const mails = (payload) => {
    switch (payload.primaryMailID) {
        case 1: return {
            mailId: 1,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "nextMail",
                    "mailId": 2
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 1,
                            "options": [
                                2
                            ]
                        }
                    ]
                }

            ]
        }

        case 2: return {
            mailId: 2,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 2,
                            "options": [
                                9
                            ]
                        }
                    ]
                }
            ]
        }

        case 3: return {
            mailId: 3,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 3,
                            "options": [
                                10
                            ]
                        }
                    ]
                }
            ]
        }

        case 4: return {
            mailId: 4,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 4,
                            "options": [
                                23
                            ]
                        }
                    ]
                }
            ]
        }

        case 5: return {
            mailId: 5,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 5,
                            "options": [
                                24
                            ]
                        }
                    ]
                }
            ]
        }

        case 7: return {
            mailId: 7,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 6,
                            "options": [
                                26
                            ]
                        }
                    ]
                }
            ]
        }

        case 8: return {
            mailId: 8,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 7,
                            "options": [
                                28
                            ]
                        }
                    ]
                }
            ]
        }

        case 9: return {
            mailId: 9,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 8,
                            "options": [
                                30
                            ]
                        }
                    ]
                }
            ]
        }

        case 10: return {
            mailId: 10,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 9,
                            "options": [
                                34, 37, 33
                            ]
                        },
                        {
                            "messageGroupId": 10,
                            "options": [
                                43
                            ]
                        }
                    ]
                }
            ]
        }

        case 11: return {
            mailId: 11,
            actionThread: [
                {
                    "type": "mail_read",
                    "status": true
                },
                {
                    "type": "compose",
                    "to": [
                        3,
                        4
                    ],
                    "cc": [
                        1,
                        2
                    ],
                    "body": [
                        {
                            "messageGroupId": 12,
                            "options": [
                                9
                            ]
                        }
                    ]
                }
            ]
        }
    };

};



// WEBPACK FOOTER //
// /src/fakeApi/postResponseMails.js